<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">

                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                        <h1>Reset Password</h1>
                        <p>To reset your password please provide your Msacco email</p>
                    </div>
                    <form role="form">
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Email"
                                    addon-left-icon="ni ni-email-83"
                                    v-model="model.email">
                        </base-input>
                        <div class="text-center" v-if="loaderStatus">
                            <loader></loader>
                        </div>
                        <div class="text-center" v-else>
                            <base-button type="primary" class="my-4" @click="send_email"> Send Reset Instructions </base-button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-6">
                    <a href="#" class="text-light"><small><router-link to="login">Login?</router-link></small></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loader from "../components/Loader"
    export default {
        name: "ForgotPassword",
        data() {
            return {
                model: {
                    email: ''
                }
            }
        },
        components: {
            Loader
        },
        methods: {
            send_email(){
                this.$store.dispatch('forgotpassword_function', this.model)
            },
        },
    }
</script>

<style scoped>

</style>
